"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBrokenAlertFiltersMeta = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var dataLoaders_1 = require("../../../dataLoaders");
var internal_1 = require("../../../internal");
/**
 * the amount of elements to load, this should be small enough to be efficient,
 * and large enough to always be longer than the broken alert filters display
 */
var DEFAULT_ATTRIBUTE_ELEMENT_COUNT = 20;
/**
 * @internal
 */
function useBrokenAlertFiltersMeta(_a) {
    var _this = this;
    var backend = _a.backend, brokenAlertFilters = _a.brokenAlertFilters, workspace = _a.workspace, onCancel = _a.onCancel, onError = _a.onError, onLoading = _a.onLoading, onPending = _a.onPending, onSuccess = _a.onSuccess;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspace(workspace);
    ts_invariant_1.default(effectiveBackend, "The backend in useBrokenAlertFiltersMeta must be defined. Either pass it as a config prop or make sure there is a BackendProvider up the component tree.");
    ts_invariant_1.default(effectiveWorkspace, "The workspace in useBrokenAlertFiltersMeta must be defined. Either pass it as a config prop or make sure there is a WorkspaceProvider up the component tree.");
    var promise = brokenAlertFilters
        ? function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var filtersToLoad, dateDatasetLoader, dateDatasetsPromise, filterDataPromise, _a, filterData, dateDatasets, attributeFiltersMeta;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        filtersToLoad = brokenAlertFilters.filter(internal_1.isBrokenAlertAttributeFilterInfo);
                        dateDatasetLoader = dataLoaders_1.dateDatasetsDataLoaderFactory.forWorkspace(effectiveWorkspace);
                        dateDatasetsPromise = dateDatasetLoader.getDateDatasets(effectiveBackend);
                        filterDataPromise = Promise.all(filtersToLoad.map(function (filter) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var attributeFilter, displayForm, attributesService, _a, elements, displayFormData;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        attributeFilter = filter.alertFilter.attributeFilter;
                                        if (!sdk_model_1.isAttributeElementsByRef(attributeFilter.attributeElements)) {
                                            throw new sdk_backend_spi_1.NotSupported("Only URI attribute filters are supported in useBrokenAlertFiltersMeta");
                                        }
                                        displayForm = attributeFilter.displayForm;
                                        attributesService = effectiveBackend.workspace(effectiveWorkspace).attributes();
                                        return [4 /*yield*/, Promise.all([
                                                attributesService
                                                    .elements()
                                                    .forDisplayForm(displayForm)
                                                    .withLimit(DEFAULT_ATTRIBUTE_ELEMENT_COUNT)
                                                    .withOptions({
                                                    uris: attributeFilter.negativeSelection
                                                        ? undefined // for negative filters we need to load the items NOT selected, however there is no way of doing that, so we load everything
                                                        : attributeFilter.attributeElements.uris,
                                                    includeTotalCountWithoutFilters: true,
                                                })
                                                    .query(),
                                                attributesService.getAttributeDisplayForm(displayForm),
                                            ])];
                                    case 1:
                                        _a = _b.sent(), elements = _a[0], displayFormData = _a[1];
                                        return [2 /*return*/, {
                                                elements: elements,
                                                displayForm: displayForm,
                                                title: displayFormData.title,
                                            }];
                                }
                            });
                        }); }));
                        return [4 /*yield*/, Promise.all([filterDataPromise, dateDatasetsPromise])];
                    case 1:
                        _a = _b.sent(), filterData = _a[0], dateDatasets = _a[1];
                        attributeFiltersMeta = filterData.reduce(function (acc, curr) {
                            acc[sdk_model_1.objRefToString(curr.displayForm)] = {
                                title: curr.title,
                                totalElementsCount: curr.elements.totalCount,
                                validElements: curr.elements.items,
                            };
                            return acc;
                        }, {});
                        return [2 /*return*/, {
                                attributeFiltersMeta: attributeFiltersMeta,
                                dateDatasets: dateDatasets.map(function (ds) { return ds.dataSet; }),
                            }];
                }
            });
        }); }
        : null;
    return sdk_ui_1.useCancelablePromise({ promise: promise, onCancel: onCancel, onError: onError, onLoading: onLoading, onPending: onPending, onSuccess: onSuccess }, [
        effectiveBackend,
        effectiveWorkspace,
        brokenAlertFilters,
    ]);
}
exports.useBrokenAlertFiltersMeta = useBrokenAlertFiltersMeta;
//# sourceMappingURL=useBrokenAlertFiltersMeta.js.map